export const inviewFull = (selector, options) => {
  const els = document.querySelectorAll(selector);

  const cb = function (entries, observer) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio >= 0.8) {
        setTimeout(() => {
          entry.target.classList.add("inview-is-visible");
          observer.unobserve(entry.target);
        }, 100);
      }
    });
  };

  const io = new IntersectionObserver(cb, options);

  els.forEach((el) => {
    io.observe(el);
  });
};
